import template from './noteAddToTicket.template.html';

export default {
  template,
  bindings: {
    idContact: '<',
    note: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      ticketsService,
      ticketService,
      noteService,
      notesService,
      uiService,
      TICKET
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isReady = false;
      ctrl.availableTickets = [{ name: 'Please wait...' }];
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {};

      this.loadTickets = () =>
        ticketsService
          .getByContact({
            idContact: ctrl.idContact,
            isActive: true,
            fields: TICKET.FIELDS.BOARD
          })
          .then((tickets) => {
            ctrl.availableTickets = tickets;
          });

      this.addToTicket = (ticket) => {
        const noteToAdd = angular.copy(ctrl.note);
        noteToAdd.id = '';
        noteToAdd.idTicket = ticket.id;
        noteToAdd.idWorkflow = ticket.idWorkflow;
        noteToAdd.idOwner = ticket.idOwner;
        noteToAdd.idContact = '';
        noteToAdd.idOwnerContact = '';
        noteToAdd.isActive = true;

        uiService.toast({
          text: {
            p1: 'Adding note to',
            p2: ticket.name,
            p3: 'Please wait...'
          }
        });

        noteService.createNote(noteToAdd).then((data) => {
          notesService.clearCache();
          if (data.status) {
            uiService.toast({
              text: {
                p1: 'Note',
                p2: ctrl.note.getExcerpt(),
                p3: `has been added to ${ticket.name}`
              },
              success: true
            });
          } else {
            uiService.toast({
              text: {
                p1: 'Note',
                p2: ctrl.note.getExcerpt(),
                p3: `adding failed for ${ticket.name}`
              },
              warn: true
            });
          }
        });
      };
      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {};

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = () => {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = () => {};
    }
  }
};
